import { Field, ErrorMessage, FieldProps } from 'formik';
import { Select as AntSelect, Flex } from 'antd';
import clsx from 'clsx';
import TextError from 'components/TextError';
import FieldLabel from 'components/FieldLabel';
import If from 'components/If';
import { SelectProps } from 'utils/globalTypes';
import DropdownIcon from 'assets/common/dropdown.svg?react';
import styles from './index.module.scss';

function Select<ValueType>(props: SelectProps) {
  const {
    label,
    name,
    qaSelector,
    showErrMsg = true,
    info,
    className,
    ...rest
  } = props;
  return (
    <Flex vertical align='flex-start' className='formFieldContainer'>
      <FieldLabel label={label} info={info} />
      <Field name={name}>
        {({ field, meta, form }: FieldProps) => {
          const { setFieldValue } = form;
          const fieldStatus = meta.touched && meta.error ? 'error' : '';
          const onChange = (value: ValueType) => {
            setFieldValue(name, value);
          };
          return (
            <AntSelect
              status={fieldStatus}
              id={name}
              suffixIcon={<DropdownIcon />}
              {...field}
              {...rest}
              className={clsx('fullWidth', styles.select, className)}
              onChange={onChange}
              data-qa-selector={qaSelector}
            />
          );
        }}
      </Field>
      <If condition={showErrMsg}>
        <ErrorMessage name={name}>
          {(msg) => <TextError msg={msg} qaSelector={`${qaSelector}-error`} />}
        </ErrorMessage>
      </If>
    </Flex>
  );
}

export default Select;
